import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getMyReportsAsync, deleteAccountReportAsync, CopyReportByReportIdAsync } from "./MyReportsSlice";
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown } from 'react-bootstrap';
import clsx from "clsx";
import Loader from "../../../common/Loader";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { getAccountFeatureAsync, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { getValueFromResource } from "../../../common/timeLiveFunction";
import ScheduleReport from "../customReportView/ScheduleReport";
import { getFiltersByReportAsync } from "../customReportView/CustomReportViewSlice";
import ScheduleReportList from "../customReportView/ScheduleReportList";
import { getAccountFeature } from "../../../common/timesheetFunction";
export const MyReports = () => {
    const dispatch = useAppDispatch();
    const { isReload, isLoading } = useAppSelector((state) => state.myReports)
    const [myReportsArray, setMyReportsArray] = useState<any | ''>([]);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const [favorites, setFavorites] = useState<string[]>([]);
    const [showScheduleReport, setShowScheduleReport] = useState(false);
    const [AccountReportId, setAccountReportId] = useState('');
    const [tab, setTab] = useState('Reports');
    const [showScheduleTab, setShowScheduleTab] = useState<boolean | null>(null);

     useEffect(() => {
        if (location.state && location.state.targetTab) {
            setTab(location.state.targetTab);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const toggleFavorite = (reportId: string) => {
        setFavorites((prev) =>
            prev.includes(reportId) ? prev.filter((id) => id !== reportId) : [...prev, reportId]
        );
    };

    useEffect(() => {
        getMyReports();
    }, [])

    useEffect(() => {
        if (isReload) {
            getMyReports();
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getAccountFeatureAsync()).then((res: any) => {
            if (res?.meta?.requestStatus === 'fulfilled') {
                const data = res?.payload?.AccountFeatures || [];
                const hasScheduleFeature = data.some((item: any) => item.SystemFeatureId?.toLowerCase() === "356282ab-9aa8-45ae-8d2c-b1a7453a93d4");
                setShowScheduleTab(hasScheduleFeature);
            }else {
                setShowScheduleTab(false);
            }
        })
            .catch((error) => {
                console.log(error);
            })
    }, []);

    const getMyReports = () => {
        dispatch(getMyReportsAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.StatusCode === "200") {
                    const groupedData = originalPromiseResult.Data.reduce((result: any, currentItem: any) => {
                        // Extract the property by which you want to group (e.g., 'category')
                        const groupKey = currentItem.AccountReportCategory;
                        // Ensure the result[groupKey] exists
                        if (!result[groupKey]) {
                            result[groupKey] = [];
                        }
                        // Push the current item to the corresponding group
                        result[groupKey].push(currentItem);
                        // Return the result for the next iteration
                        return result;
                    }, {});

                    // Extract keys and sort them in descending order
                    const sortedKeys = Object.keys(groupedData).sort((a, b) => b.localeCompare(a));

                    // Create a new object with sorted keys
                    const sortedGroupedData = sortedKeys.reduce((sortedResult: any, key: string) => {
                        sortedResult[key] = groupedData[key];
                        return sortedResult;
                    }, {});
                    setMyReportsArray(sortedGroupedData);
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const isDeleteVisible = (item: any) => {
        return item.AccountReportId === "620828e0-2b5a-4881-bda8-ff522d1b2046" ? false : (!item.AccountId ? false : (!item.ReportPageName ? true : false))
    };

    const isPermissionVisible = (item: any) => {
        return item.AccountReportId === "bd95c198-9077-49ec-a62c-9f169c1aac67" ? false : true;
    };

    const onDeleteClick = (AccountReportId: string) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountReportAsync(AccountReportId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Report delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
            });
    }

    const onCopyClick = (e: any, AccountReportId: string) => {
        e.preventDefault();
        dispatch(CopyReportByReportIdAsync(AccountReportId))
            .unwrap()
            .then((originalPromiseResult) => {
                originalPromiseResult.StatusCode === "201" ?
                    ShowToast("Report copied Successfully", 'Success', "success", "toast-top-right") :
                    ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
            })
            .catch((rejectedValueOrSerializedError) => {
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            })
    }

    const onClose = () => {
        setShowScheduleReport(false);
        const overlay = document.querySelector('.drawer-overlay');
        if (overlay) {
            overlay.remove();
        }

        document.body.style.overflow = '';
        document.body.classList.remove('drawer-end-on');
    }

    const handleScheduleReport = (item: any) => {
        setShowScheduleReport(true);
        setAccountReportId(item?.AccountReportId);
        const response = dispatch(getFiltersByReportAsync(item?.AccountReportId)).unwrap().then((snap) => {
            const resource = JSON.parse(snap?.Data?.FilterData);
        })
            .catch((err) => {
                console.log(err);
            })
    }
    const onSetTab = (flag: boolean) => {
        if (flag) {
            setTab('Scheduled Reports')
        }
    }
    return (
        <>
            {/* <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle">
                         {getValueFromResource('My Reports',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {IsAdd &&
                            <a id="kt_OffCanvas"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                style={{ marginRight: '2px' }}
                                onClick={() => navigate('/customReportDesign', { state: { accountReportId: '' } })}
                            >
                                <KTIcon iconName='plus' className='fs-3' />
                                 {getValueFromResource('Add New Report',dispatch, t)}

                            </a>
                       
                        }
                    </div>
                </div>
                <div className="card-body">
                    {isLoading && <Loader />}
                    <div className="table-responsive">
                        {IsList &&
                            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                                <thead>
                                    <tr className="thHeading align-middle">
                                        <th className='w-100'>
                                            {getValueFromResource('Report Name',dispatch, t)}
                                            </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(myReportsArray).map((AccountReportCategory, index) => (
                                        <React.Fragment key={index}>
                                            <tr style={{ backgroundColor: '#F7F8F9', marginBottom: '10px' }}>
                                                <td colSpan={6}
                                                    style={{ padding: '7px 5px', marginLeft: '5px' }}
                                                    className='text-gray-800 fw-normal d-block  fw-bold'>
                                                    {t(`${AccountReportCategory}`)}

                                                </td>
                                                <td colSpan={5} >
                                                </td>  
                                            </tr>
                                            {myReportsArray[AccountReportCategory].map((item: any, innerIndex: any) => (
                                                <tr key={innerIndex}
                                                >
                                                    <td style={{padding:'8px 0px'}}>
                                                        {item.ReportNameHyperLinkVisible && (
                                                            <>
                                                              
                                                                <span
                                                                    onClick={() => {
                                                                        navigate('/customreportview', { state: { accountReportId: item.AccountReportId } });
                                                                      
                                                                    }}
                                                                    className='text-dark fw-bold d-block cursor'
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {getValueFromResource(`${item.ReportName}`, dispatch,t)}
                                                                </span>
                                                                <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                                    {getValueFromResource(`${item.ReportDescription}`, dispatch,t)}
                                                                </span>
                                                            </>
                                                        )}



                                                    </td>
                                                    <td className='text-center'>
                                                        <Dropdown
                                                            style={{ marginLeft: 1 }}
                                                            className={clsx('cursor-pointer symbol')}
                                                            data-kt-menu-attach='parent'
                                                            data-kt-menu-placement='bottom-end'
                                                        >
                                                            <Dropdown.Toggle
                                                                variant="transparent"
                                                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                data-tooltip-id="tooltip-Description"
                                                                data-tooltip-content=
                                                                 {getValueFromResource('More',dispatch, t)}
                                                                data-tooltip-place="top"
                                                            >
                                                                <i className="bi bi-three-dots fs-7"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                                {item.CustomizeHyperLink === true &&
                                                                    <div className='menu-hover-bg-sec'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0"
                                                                            onClick={() => navigate('/customreportdesign', { state: { accountReportId: item.AccountReportId } })}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-pencil-square fs-6 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title custom-menu-fontsize">
                                                                                 {getValueFromResource('Customize',dispatch, t)}
                                                                                </span>
                                                                           

                                                                        </Dropdown.Item>
                                                                    </div>
                                                                }
                                                                {IsEdit && (item.PermissionHyperLink === true && isPermissionVisible(item)) && (
                                                                    <div className='menu-hover-bg-sec'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0"
                                                                            onClick={() => navigate('/AccountReportPermission', { state: { accountReportId: item.AccountReportId } })}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title custom-menu-fontsize">
                                                                                 {getValueFromResource('Permissions',dispatch, t)}
                                                                                </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                )}
                                                                <div className="separator mt-1"></div>
                                                                {IsAdd && item.CopyHyperLink && (
                                                                    <div className='menu-hover-bg-sec'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0"
                                                                            onClick={(e) => { onCopyClick(e, item.AccountReportId) }}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-files fs-6 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title custom-menu-fontsize">
                                                                                 {getValueFromResource('Copy',dispatch, t)}
                                                                                </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                )}
                                                                {IsDelete && isDeleteVisible(item) && (
                                                                    <div className='menu-hover-bg-danger'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0"
                                                                            onClick={() => { onDeleteClick(item.AccountReportId) }}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title delete-menu custom-menu-fontsize"  >
                                                                                 {getValueFromResource('Delete',dispatch, t)}
                                                                                </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                )}

                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table >
                        }
                        {myReportsArray.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                     {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div> */}


            {/* New Report Design work */}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top fixed-top bg-white" style={{ zIndex: 10 }}>
                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Reports' })}
                                onClick={() => setTab('Reports')}
                                role='tab'
                                style={{ fontWeight: 500 }}
                            >
                                {getValueFromResource('Reports', dispatch, t)}
                            </a>
                        </li>
                        <li className='nav-item d-flex align-items-center gap-1'>
                            <a className={clsx('nav-link cursor-pointer', { active: tab === 'Scheduled Reports' && showScheduleTab, disabled: !showScheduleTab })}
                                onClick={() => {
                                    if (showScheduleTab) {
                                        setTab('Scheduled Reports');
                                    }
                                }}
                                role='tab'
                                style={{ fontWeight: 500, opacity: showScheduleTab ? 1 : 0.6, cursor: showScheduleTab ? 'pointer' : 'not-allowed' }}
                            >
                                {getValueFromResource('Scheduled Reports', dispatch, t)}

                            </a>
                            {!showScheduleTab && (
                                <span
                                    data-tooltip-id="tooltip-report"
                                    data-tooltip-content={getValueFromResource('This feature is not available in your current plan. Please contact administrator or sales@livetecs.com.', dispatch, t)}
                                    data-tooltip-place="top"
                                >
                                    <KTIcon iconName='lock-3' className='fs-1 mt-1' />
                                </span>
                            )}
                        </li>
                    </ul>
                    {/* <h3 className="card-title fw-bold headerTitle"> */}
                    {/* {t('My Reports')} */}
                    {/* {getValueFromResource('Reports', dispatch, t)}
                    </h3> */}
                    {tab === 'Reports' && <div className="card-toolbar align-items-center">
                        {IsAdd &&
                            <a id="kt_OffCanvas"
                                className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                style={{ marginRight: '2px' }}
                                // onClick={() => navigate('/customReportDesign', { state: { accountReportId: '' } })}
                                onClick={() => navigate(`/customreportdesign/${'00000000-0000-0000-0000-000000000000'}`)}
                            >
                                <KTIcon iconName='plus' className='fs-3' />
                                {/* {t(`Add New Report`)} */}
                                {getValueFromResource('Add New Report', dispatch, t)}

                            </a>
                            // <a id="kt_OffCanvas"
                            //     className='btn btn-sm btn-light-primary'
                            //     style={{ marginRight: '2px' }}
                            //     href={`../customReportDesign`}
                            // >
                            //     <KTIcon iconName='plus' className='fs-3' />{`Add New Report`}

                            // </a>
                        }
                    </div>}
                </div>
                {/* <div className="card-body" > */}
                <div className="card-Report-body">
                    {isLoading && <Loader />}
                    {tab === 'Reports' ? <div className="table-responsive">
                        {IsList &&
                            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                                <thead>

                                </thead>
                                <tbody>
                                    {Object.keys(myReportsArray).map((AccountReportCategory, index) => (

                                        <React.Fragment key={index}>

                                            <div className='section-heading'>
                                                <h2>
                                                    {/* {t(`${AccountReportCategory}`)} */}
                                                    {getValueFromResource(`${AccountReportCategory}`, dispatch, t)}
                                                </h2>
                                            </div>



                                            <div
                                                className="grid-container"
                                            >
                                                {myReportsArray[AccountReportCategory].map((item: any, innerIndex: any) => (
                                                    item.ReportNameHyperLinkVisible && (
                                                        <div key={innerIndex} className="grid-item">
                                                            <div className="Report-card position-relative">
                                                                <div className="tsNavBarInnerBoxParent flex justify-content-center flex-col gap-2 p-4">
                                                                    <div
                                                                        // onClick={() => navigate('/customreportview', { state: { accountReportId: item.AccountReportId } })}
                                                                        onClick={() => {
                                                                            if (item.AccountReportId?.toLowerCase() === "620828e0-2b5a-4881-bda8-ff522d1b2046") {
                                                                                navigate(`/monthlyreportview/${item.AccountReportId}`, { state: { ReportName: item?.ReportName } })
                                                                            } else {
                                                                                navigate(`/customreportview/${item.AccountReportId}`)
                                                                            }
                                                                        }}


                                                                        className="text-dark fw-bold d-block cursor mb-2 report-card-title"
                                                                        style={{ cursor: 'pointer', fontSize: '1.3rem', textAlign: 'center' }}
                                                                    >
                                                                        {getValueFromResource(`${item.ReportName}`, dispatch, t)}
                                                                    </div>
                                                                    <div className="report-card-description" style={{ marginTop: '10px', fontSize: '1.1rem' }}>
                                                                        {getValueFromResource(`${item.ReportDescription}`, dispatch, t)}
                                                                    </div>
                                                                </div>

                                                                {/* Dropdown & Favorite Icons */}
                                                                <div className="position-absolute top-3 end-0 head-end d-flex align-items-center p-2 mx-3">
                                                                    {(Number(1) == Number(0) &&
                                                                        <i
                                                                            className={`bi ${favorites.includes(item.AccountReportId) ? 'bi-star-fill' : 'bi-star'} fs-6 cursor-pointer`}
                                                                            onClick={() => toggleFavorite(item.AccountReportId)}
                                                                            style={{ marginRight: '-4px', color: favorites.includes(item.AccountReportId) ? "#ff9725" : "#7b8ba6" }}
                                                                        ></i>
                                                                    )}

                                                                    <Dropdown
                                                                        style={{ marginLeft: 1 }}
                                                                        className={clsx('cursor-pointer symbol')}
                                                                        data-kt-menu-attach='parent'
                                                                        data-kt-menu-placement='bottom-end'
                                                                        drop="down"
                                                                        align="end"
                                                                    >
                                                                        <Dropdown.Toggle
                                                                            variant="transparent"
                                                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                            data-tooltip-id="tooltip-Description"
                                                                            data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                                                            data-tooltip-place="top"
                                                                        >
                                                                            <i className="bi bi-three-dots fs-7"></i>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                                            {item.CustomizeHyperLink && (
                                                                                <div className='menu-hover-bg-sec'>
                                                                                    <Dropdown.Item
                                                                                        className="menu-item me-lg-0"
                                                                                        // onClick={() => navigate('/customreportdesign', { state: { accountReportId: item.AccountReportId } })}
                                                                                        onClick={() => navigate(`/customreportdesign/${item.AccountReportId}`)}

                                                                                    >
                                                                                        <span className="menu-icon custom-menu mb-2">
                                                                                            <i className="bi bi-pencil-square fs-6 iconColor">
                                                                                                <span className="path1"></span>
                                                                                                <span className="path2"></span>
                                                                                            </i>
                                                                                        </span>
                                                                                        {/* {item.CustomizeHyperLink === true && ( */}
                                                                                        <span className="menu-title custom-menu-fontsize">
                                                                                            {/* {`${t('Customize')}`} */}
                                                                                            {getValueFromResource('Customize', dispatch, t)}
                                                                                        </span>
                                                                                        {/* )} */}

                                                                                    </Dropdown.Item>
                                                                                </div>
                                                                            )}
                                                                            {IsEdit && item.PermissionHyperLink && isPermissionVisible(item) && (
                                                                                <div className='menu-hover-bg-sec'>
                                                                                    <Dropdown.Item
                                                                                        className="menu-item me-lg-0"
                                                                                        // onClick={() => navigate('/AccountReportPermission', { state: { accountReportId: item.AccountReportId } })}
                                                                                        onClick={() => navigate(`/AccountReportPermission/${item.AccountReportId}`)}
                                                                                    >
                                                                                        <span className="menu-icon custom-menu mb-2">
                                                                                            <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                                                                <span className="path1"></span>
                                                                                                <span className="path2"></span>
                                                                                            </i>
                                                                                        </span>
                                                                                        <span className="menu-title custom-menu-fontsize">
                                                                                            {/* {`${t('Permissions')}`} */}
                                                                                            {getValueFromResource('Permissions', dispatch, t)}
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                </div>)}
                                                                            {showScheduleTab && <div className='menu-hover-bg-sec'>
                                                                                <Dropdown.Item
                                                                                    className="menu-item me-lg-0"
                                                                                    onClick={() => handleScheduleReport(item)}
                                                                                >
                                                                                    <span className="menu-icon custom-menu mb-2">
                                                                                        <i className="bi bi-calendar-check fs-6 iconColor">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                        </i>
                                                                                    </span>
                                                                                    <span className="menu-title custom-menu-fontsize">
                                                                                        {getValueFromResource('Schedule', dispatch, t)}
                                                                                    </span>
                                                                                </Dropdown.Item>
                                                                            </div>}

                                                                            {IsAdd && item.CopyHyperLink && (
                                                                                <div className='menu-hover-bg-sec'>
                                                                                    <Dropdown.Item
                                                                                        className="menu-item me-lg-0"
                                                                                        onClick={(e) => { onCopyClick(e, item.AccountReportId) }}
                                                                                    >
                                                                                        <span className="menu-icon custom-menu mb-2">
                                                                                            <i className="bi bi-files fs-6 iconColor">
                                                                                                <span className="path1"></span>
                                                                                                <span className="path2"></span>
                                                                                            </i>
                                                                                        </span>
                                                                                        <span className="menu-title custom-menu-fontsize">
                                                                                            {/* {`${t('Copy')}`} */}
                                                                                            {getValueFromResource('Copy', dispatch, t)}
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                </div>
                                                                            )}
                                                                            {IsDelete && isDeleteVisible(item) && (
                                                                                <div className='menu-hover-bg-danger'>
                                                                                    <Dropdown.Item
                                                                                        className="menu-item me-lg-0"
                                                                                        onClick={() => { onDeleteClick(item.AccountReportId) }}
                                                                                    >
                                                                                        <span className="menu-icon custom-menu mb-2">
                                                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color " >
                                                                                                <span className="path1"></span>
                                                                                                <span className="path2"></span>
                                                                                            </i>
                                                                                        </span>
                                                                                        <span className="menu-title delete-menu custom-menu-fontsize"  >
                                                                                            {/* {`${t('Delete')}`} */}
                                                                                            {getValueFromResource('Delete', dispatch, t)}
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                </div>
                                                                            )}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                ))}
                                            </div>

                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table >
                        }
                        {myReportsArray.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}
                                </p>
                            </div>
                        }
                    </div>
                        : (
                            <ScheduleReportList />
                        )}
                </div>
            </div>
             {showScheduleReport && <ScheduleReport onClose={onClose} AccountReportId={AccountReportId} onSetTab={onSetTab} moveTo={'ScheduleReportTab'}/>}
            <ReactTooltip
                id="tooltip-report"
                place="top"
                style={{ fontSize: "12px", fontWeight: "normal", padding: "8px 12px", borderRadius: "6px", backgroundColor: "#1F2937", color: "white", zIndex: 999999, maxWidth: "250px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
            />
        </>
    )
}